module.exports = __webpack_public_path__ + "static/media/atlas-logo-only.4a9755db.svg";